export default "__VITE_ASSET__967f5662__"